export default interface IAppointmentBookingResponse {
	http_status: number;
	stageId: string;
	stage: number;
	status: boolean;
	doctorFullName: string;
	appointmentTypeName: string;
	appointmentStartTime: string;
	stripePaymentIntentId: string;
	clientSecret: string;
	stripeCustomerId: string;
	stripePaymentMethodId: string;
	message: string;
	isPrepaid: boolean;
}

export const InitialAppointmentBookingResponseState: IAppointmentBookingResponse = {
	http_status: 0,
	stageId: "",
	stage: 0,
	status: false,
	doctorFullName: "",
	appointmentTypeName: "",
	appointmentStartTime: "",
	stripePaymentIntentId: "",
	clientSecret: "",
	stripeCustomerId: "",
	stripePaymentMethodId: "",
	message: "",
	isPrepaid: false,
};
